import {
  QueryFunction,
  QueryKey,
  useQuery,
  UseQueryOptions,
} from '@tanstack/react-query';
import { App } from 'antd';
import { handleError } from 'api';
import {
  FieldsApiService,
  FieldsBookingsParams,
  FieldsBookingsResponse,
} from 'features/fields';

import { fieldsBookingsQueryKeys } from './query-keys';

const { getFieldsBookings } = FieldsApiService();

const getFieldsBookingsQuery = (
  params: FieldsBookingsParams,
  options?: UseQueryOptions<FieldsBookingsResponse>,
): {
  queryKey: QueryKey;
  queryFn: QueryFunction<FieldsBookingsResponse>;
  options?: UseQueryOptions<FieldsBookingsResponse>;
} => ({
  queryKey: fieldsBookingsQueryKeys.list(params),
  queryFn: ({ signal }) => getFieldsBookings(params, { config: { signal } }),
  ...options,
});

export const useGetFieldsBookings = (
  params: FieldsBookingsParams,
  options?: UseQueryOptions<FieldsBookingsResponse>,
) => {
  const { message } = App.useApp();

  return useQuery<FieldsBookingsResponse, Error>(
    getFieldsBookingsQuery(params, {
      onError: (error: unknown) => {
        const uiMessage = handleError(error);

        message.error(uiMessage);
      },
      ...options,
    }),
  );
};
